import {Injectable} from '@angular/core';
import {SettingsService} from './settings.service';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {StorageService} from './storage.service';
import {DayEvents} from "../models";


@Injectable()
export class EventsService {
  apiUrl: string;
  token: string;


  constructor(private http: HttpClient,
              private settings: SettingsService,
              private storage: StorageService) {
    this.apiUrl = this.settings.apiUrl;
    this.token = this.storage.accessToken;

  }

  getEvents(params): Observable<any> {
    const clientId = this.storage.userId;
    const filteredByClient =  `client/${clientId}` ;
    return this.http.get(`${this.apiUrl}/events/${filteredByClient}` ).pipe(map((resp: any) => {
      // console.log('!!!!!events resp', resp);
      return resp;

    }));
    return null;
  }

  getDayEvents(params): Observable<any> {
    const clientId = this.storage.userId;
    const filteredByClient =  `client/${clientId}` ;
    return this.http.get(`${this.apiUrl}/events/${filteredByClient}` ).pipe(map((resp: any) => {
      // console.log('!!!!!events resp', resp);
      return resp.map(item => {
        return new DayEvents().setFromApiModel(item);
      })

    }));
    return null;
  }

  getUnshowedEvents(): Observable<any> {
    return this.http.get(`${this.apiUrl}/events-unshowed-web/${this.storage.userId}`).pipe(map((resp: any) => {
      return resp;

    }));
    return null;
  }
}
